import * as React from 'react';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { Col, Row, Form } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { TextFormGroup, RichTextFormGroup } from '../../uiComponents/input/FormGroups';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import { Spoergsmaal } from '../../models/Spoergsmaal';
import { EditorState } from 'draft-js';
import DraftHelper from '../../infrastructure/DraftHelper';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import NotificationQueue from '../../uiComponents/layout/NotificationQueue';
import NotificationData from '../../uiComponents/layout/NotificationData';

export interface OftestStilledeSpoergsmaalContainerProps extends RouteComponentProps<any> {
}

interface OftestStilledeSpoergsmaalContainerState {
    spoergsmaal: Spoergsmaal;
    editorState: EditorState;
    isSubmitting: boolean;
    validationResult: ValidationResult;
    isSaved: boolean;
}

class OftestStilledeSpoergsmaalContainer extends React.Component < OftestStilledeSpoergsmaalContainerProps,
OftestStilledeSpoergsmaalContainerState> {

    constructor(props: OftestStilledeSpoergsmaalContainerProps) {
        super(props);
        this.state = {
            spoergsmaal: new Spoergsmaal(),
            editorState: DraftHelper.getEmptyEditorState(),
            isSubmitting: false,
            validationResult: new ValidationResult(),
            isSaved: false
        };

        this.onOpgaveEditorChange = this
            .onOpgaveEditorChange
            .bind(this);
        this.onSpoergsmaalChanged = this
            .onSpoergsmaalChanged
            .bind(this);
        this.onSave = this
            .onSave
            .bind(this);
    }

    onSpoergsmaalChanged(fieldName: string, value: string) {
        let spoergsmaal = this.state.spoergsmaal;
        spoergsmaal[fieldName] = value;

        this.setState({spoergsmaal: spoergsmaal});
    }

    getEditorState(): EditorState {
        return DraftHelper.getContentAsEditorState(this.state.spoergsmaal.tekst);
    }

    onOpgaveEditorChange(editorState: EditorState) {
        let spoergsmaal = this.state.spoergsmaal;
        if (spoergsmaal !== undefined) {
            spoergsmaal.tekst = DraftHelper.getEditorStateAsHtml(editorState);
        }

        this.setState({editorState: editorState, spoergsmaal: spoergsmaal});
    }    

    onSpoergsmaalSaved(validationResult: ValidationResult, notificationMessage: string) {
        this.setState({ validationResult: validationResult, isSaved: validationResult.isValid ? true : false, isSubmitting: false });
        if (validationResult.isValid) {
            NotificationQueue.push(new NotificationData(notificationMessage, '', 'success'));
            this.props.history.goBack();            
        }
    }

    onSave() {
        this.setState({isSubmitting: true});
        var param = this.props.match.params.opgaveId;
        var self = this;
        var notificationMessage = 'Spørgsmålet er sendt.';
        const spoergsmaal = this.state.spoergsmaal;
        spoergsmaal.opgaveId = param;

        createApiCaller().createSpoergsmaal(spoergsmaal)
        .then(function(validationResult: ValidationResult) {
            self.onSpoergsmaalSaved(validationResult, notificationMessage);
        });
    }

    render() {
        // if (this.state.isSaved) {
        //     return <Redirect to='/' />;
        // }

        return (
            <PageWrapper className='oftest-stillede-spoergsmaal-container'>
                <PageTitle title='Oftest stillede spørgsmål'/>
                <ContentWrapper>
                    <SectionGroup header='Stil os dit spørgsmål'>
                        <Form onSubmit={this.onSave}>
                            <Section>
                                <Row>
                                    <Col md={3} mdOffset={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Navn*'
                                            name='navn'
                                            placeholder='Skriv navn...'
                                            value={this.state.spoergsmaal.navn}
                                            onChange={this.onSpoergsmaalChanged}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3} mdOffset={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='E-mail*'
                                            name='email'
                                            placeholder='Skriv e-mail...'
                                            value={this.state.spoergsmaal.email}
                                            onChange={this.onSpoergsmaalChanged}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Telefonnummer*'
                                            name='telefonNummer'
                                            placeholder='Skriv telefonnummer...'
                                            value={this.state.spoergsmaal.telefonNummer}
                                            onChange={this.onSpoergsmaalChanged}
                                        />
                                    </Col>
                                </Row>
                            </Section>
                            <Section>
                                <Row>
                                    <Col md={3} mdOffset={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Skolens navn*'
                                            name='skoleNavn'
                                            placeholder='Skriv skolens navn...'
                                            value={this.state.spoergsmaal.skoleNavn}
                                            onChange={this.onSpoergsmaalChanged}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Din funktion*'
                                            name='funktion'
                                            placeholder='...'
                                            value={this.state.spoergsmaal.funktion}
                                            onChange={this.onSpoergsmaalChanged}
                                        />
                                    </Col>
                                </Row>
                            </Section>
                            <Section>
                                <Row>
                                    <Col md={6} mdOffset={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Emne*'
                                            name='emne'
                                            placeholder='Skriv skolens emne...'
                                            value={this.state.spoergsmaal.emne}
                                            onChange={this.onSpoergsmaalChanged}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} mdOffset={3}>
                                        <RichTextFormGroup
                                            name='tekst'
                                            label='Tekst*'
                                            errorMessages={this.state.validationResult.errorMessages}
                                            onEditorChange={(editorState: EditorState) => this.onOpgaveEditorChange(editorState)}
                                            editorState={this.state.editorState}
                                        />
                                    </Col>
                                </Row>
                            </Section>
                            <ButtonSection>
                                <SubmitButton isSubmitting={this.state.isSubmitting}>Send spørgsmål</SubmitButton>
                            </ButtonSection>
                        </Form>

                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default OftestStilledeSpoergsmaalContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/OftestStilledeSpoergsmaal/OftestStilledeSpoergsmaalContainer.tsx